/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Nabis NY Web API
 * Nabis NY Web API docs
 * OpenAPI spec version: 1.0
 */
import axios from 'axios';
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import useSwr from 'swr';
import type { SWRConfiguration, Key } from 'swr';
import type {
  OrganizationEntity,
  CreateOrganizationDto,
  OrganizationsControllerFindManyWithPagination200,
  OrganizationsControllerFindManyWithPaginationParams,
  UpdateOrganizationDto,
} from '../nabisNYWebAPI.schemas';

export const organizationsControllerCreate = (
  createOrganizationDto: CreateOrganizationDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganizationEntity>> => {
  return axios.post(`/api/v1/organizations`, createOrganizationDto, options);
};

export const organizationsControllerFindManyWithPagination = (
  params: OrganizationsControllerFindManyWithPaginationParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganizationsControllerFindManyWithPagination200>> => {
  return axios.get(`/api/v1/organizations`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getOrganizationsControllerFindManyWithPaginationKey = (
  params: OrganizationsControllerFindManyWithPaginationParams,
) => [`/api/v1/organizations`, ...(params ? [params] : [])] as const;

export type OrganizationsControllerFindManyWithPaginationQueryResult = NonNullable<
  Awaited<ReturnType<typeof organizationsControllerFindManyWithPagination>>
>;
export type OrganizationsControllerFindManyWithPaginationQueryError = AxiosError<unknown>;

export const useOrganizationsControllerFindManyWithPagination = <TError = AxiosError<unknown>>(
  params: OrganizationsControllerFindManyWithPaginationParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof organizationsControllerFindManyWithPagination>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    axios?: AxiosRequestConfig;
  },
) => {
  const { swr: swrOptions, axios: axiosOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getOrganizationsControllerFindManyWithPaginationKey(params) : null));
  const swrFn = () => organizationsControllerFindManyWithPagination(params, axiosOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const organizationsControllerFindOne = (
  organizationId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganizationEntity>> => {
  return axios.get(`/api/v1/organizations/${organizationId}`, options);
};

export const getOrganizationsControllerFindOneKey = (organizationId: string) =>
  [`/api/v1/organizations/${organizationId}`] as const;

export type OrganizationsControllerFindOneQueryResult = NonNullable<
  Awaited<ReturnType<typeof organizationsControllerFindOne>>
>;
export type OrganizationsControllerFindOneQueryError = AxiosError<unknown>;

export const useOrganizationsControllerFindOne = <TError = AxiosError<unknown>>(
  organizationId: string,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof organizationsControllerFindOne>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    axios?: AxiosRequestConfig;
  },
) => {
  const { swr: swrOptions, axios: axiosOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!organizationId;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getOrganizationsControllerFindOneKey(organizationId) : null));
  const swrFn = () => organizationsControllerFindOne(organizationId, axiosOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const organizationsControllerUpdate = (
  organizationId: string,
  updateOrganizationDto: UpdateOrganizationDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganizationEntity>> => {
  return axios.patch(`/api/v1/organizations/${organizationId}`, updateOrganizationDto, options);
};

export const organizationsControllerRemove = (
  organizationId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.delete(`/api/v1/organizations/${organizationId}`, options);
};

export const organizationsControllerFindOneByUrlSlug = (
  organizationUrlSlug: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganizationEntity>> => {
  return axios.get(`/api/v1/organizations/url-slug/${organizationUrlSlug}`, options);
};

export const getOrganizationsControllerFindOneByUrlSlugKey = (organizationUrlSlug: string) =>
  [`/api/v1/organizations/url-slug/${organizationUrlSlug}`] as const;

export type OrganizationsControllerFindOneByUrlSlugQueryResult = NonNullable<
  Awaited<ReturnType<typeof organizationsControllerFindOneByUrlSlug>>
>;
export type OrganizationsControllerFindOneByUrlSlugQueryError = AxiosError<unknown>;

export const useOrganizationsControllerFindOneByUrlSlug = <TError = AxiosError<unknown>>(
  organizationUrlSlug: string,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof organizationsControllerFindOneByUrlSlug>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    axios?: AxiosRequestConfig;
  },
) => {
  const { swr: swrOptions, axios: axiosOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!organizationUrlSlug;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getOrganizationsControllerFindOneByUrlSlugKey(organizationUrlSlug) : null));
  const swrFn = () => organizationsControllerFindOneByUrlSlug(organizationUrlSlug, axiosOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};
